import { Box, FormControl, FormControlLabel, Tabs } from '@mui/material';
import styled from 'styled-components';
import { colors, fontWeight, fontSize } from '../../../theme';

interface SurveyStyledProps {
    $surveychecked?: boolean
}

export const CardSurveyStyled = styled(FormControlLabel)(({ $surveychecked }: SurveyStyledProps) => `
&& {
    box-shadow: 0px 10px 60px rgba(33, 22, 69, 0.04);
    border-radius: 8px;
    padding: 12px;
    flex-direction: column;
    align-items: flex-start;
    margin: 4px 0;
    border: 1px solid;
    background-color: ${$surveychecked ? colors.lighten : colors.grey000};
    border-color: ${$surveychecked ? colors.default : 'transparent'};
    .MuiCheckbox-root {
        display: none;
    }
    &: hover {
        background-color: ${$surveychecked ? colors.lighten : colors.grey600};
        border-color:  ${$surveychecked ? colors.default : 'transparent'};

    }
}
`);

export const FormControlStyled = styled(FormControl)`
    && { width: 100%;
    max-height: 70vh;
    overflow-y: scroll;
    padding-right: 12px;
    &::-webkit-scrollbar {
        width: 2px;
        background-color: ${colors.grey500};
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${colors.grey400};
    }
}
`;

export const LoaderContentStyled = styled.div`
    && {
        display: flex;
        gap: 10px;
        vertical-align: middle;
        margin: 20px;
        align-items: center;
    }
`;

export const TabsSurveyCreationStyled = styled(Tabs)`
    border-bottom: 1px solid ${colors.grey500};

    && .MuiTabs-indicator {
        background-color: ${colors.default};
    }
`;

export const BoxModalStyled = styled(Box)`
  background: ${colors.grey800};
  font-weight: ${fontWeight.semiRegular};
  font-size: ${fontSize.sm};
  color: ${colors.grey400};
  padding: 48px 32px 32px;
  border-radius: 8px;
  &:focus-visible {
    outline:none;
  }
  max-height: 100%;
  overflow-y: auto;
  height: 100%
`;
